import { Quote, Star } from "lucide-react";

const BG =
  "https://static.prod-images.emergentagent.com/jobs/1c7c4ca0-0fe5-495c-ac8a-1ceb1854f3d5/images/147d3f57781d5741abcd333d33bb94e8646e6a5e9479207144eaa0854fbeff13.png";

const REVIEWS = [
  {
    name: "Deah Shelton",
    meta: "11 reviews · 2 photos",
    source: "Google Review",
    body: "My Mom was always clean, comfortable, and happy for the many months she lived at Carlene's. I am so thankful for the exceptional care and love she received there until we had to say goodbye to her in April.",
    tone: "forest",
  },
  {
    name: "Kristin Kunze",
    meta: "4 reviews",
    source: "Google Review",
    body: "My grandmother lived here for many years. My grandfather and our entire family were very happy with the care she received. Most of my visits were unannounced and always enjoyable. Grandma always looked nice and smelled good. She was happy and content. It felt like a home away from home. As a caregiver myself I would definitely feel confident in placing a loved one in Karie's care.",
    tone: "cream",
  },
  {
    name: "Cindy Adams",
    meta: "Local Guide · 6 reviews · 12 photos",
    source: "Google Review",
    body: "My mom lived at Carlene's Comfort Care for several months until she passed away. Karie gave her exceptional care. Our family was very pleased. She was always clean, well fed and well cared for. The atmosphere was calm, peaceful & clean — no bad odors either, like so many other care homes we had visited. The outdoor gardens are an added bonus, they are so beautiful. I would highly recommend Carlene's if your loved one needs care.",
    tone: "cream",
  },
  {
    name: "Sarah Fields",
    meta: "1 review",
    source: "Google Review",
    body: "This place took my mother in-law in on short notice. She needed a lot of help that I couldn't provide, since I still work fulltime. They helped me so much with her and made her feel comfortable. They stayed with her when I couldn't be there, all the way to the end of her time with us. Thank you so much for everything that you did for her!!",
    tone: "forest",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 md:py-36 overflow-hidden"
    >
      <img
        src={BG}
        alt=""
        aria-hidden
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-[#F4F1EA]/88" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <p className="reveal text-xs uppercase tracking-[0.3em] font-semibold text-[#667B68]">
            Testimonials
          </p>
          <h2
            className="reveal font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-[#1C2A24] mt-4"
            data-testid="testimonials-title"
            style={{ transitionDelay: "80ms" }}
          >
            Words from the
            <br className="hidden sm:block" />{" "}
            families we serve.
          </h2>
          <p
            className="reveal mt-5 text-[16px] text-[#3E574B] leading-relaxed"
            style={{ transitionDelay: "140ms" }}
          >
            Real Google reviews from families who entrusted us with their
            loved ones.
          </p>
        </div>

        <div className="mt-14 md:mt-20 grid md:grid-cols-2 gap-6 md:gap-8 items-start">
          {REVIEWS.map((r, i) => (
            <ReviewCard key={r.name} review={r} delay={i * 90} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ReviewCard({ review, delay }) {
  const forest = review.tone === "forest";
  return (
    <article
      data-testid={`testimonial-${review.name.toLowerCase().replace(/\s+/g, "-")}`}
      className={`reveal rounded-3xl p-7 sm:p-9 transition-all duration-500 hover:-translate-y-1 ${
        forest
          ? "bg-[#2C4C3B] text-white shadow-[0_20px_60px_-24px_rgba(44,76,59,0.45)]"
          : "bg-white/90 backdrop-blur-sm border border-white/60 text-[#1C2A24] shadow-[0_16px_48px_-24px_rgba(44,76,59,0.2)]"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="flex items-center justify-between">
        <Quote
          className={`w-8 h-8 ${forest ? "text-[#A67C52]" : "text-[#A67C52]"}`}
        />
        <div className="flex items-center gap-1 text-[#C9A24A]">
          {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className="w-4 h-4 fill-current" />
          ))}
        </div>
      </div>

      <blockquote
        className={`font-heading mt-5 text-[22px] sm:text-[24px] leading-[1.4] ${
          forest ? "text-white" : "text-[#1C2A24]"
        }`}
      >
        &ldquo;{review.body}&rdquo;
      </blockquote>

      <div
        className={`mt-6 pt-5 border-t flex items-center justify-between gap-3 ${
          forest ? "border-white/15" : "border-[#E5E1D8]"
        }`}
      >
        <div>
          <p
            className={`font-semibold text-[15px] ${
              forest ? "text-white" : "text-[#1C2A24]"
            }`}
          >
            {review.name}
          </p>
          <p
            className={`text-[11px] uppercase tracking-[0.18em] mt-1 ${
              forest ? "text-[#F4F1EA]/60" : "text-[#667B68]"
            }`}
          >
            {review.meta}
          </p>
        </div>
        <span
          className={`text-[10px] uppercase tracking-[0.22em] font-semibold shrink-0 ${
            forest ? "text-[#F4F1EA]/70" : "text-[#667B68]"
          }`}
        >
          {review.source}
        </span>
      </div>
    </article>
  );
}
